import { Link } from 'react-router-dom';

export default function BotHoneypot() {
  // Invisible honeypot links - only bots crawling the DOM source will follow these
  // Real users won't see or interact with these
  return (
    <div
      aria-hidden="true"
      className="absolute h-[1px] w-[1px] overflow-hidden opacity-0 pointer-events-none"
      tabIndex={-1}
    >
      <Link to="/bot-honeypot?source=footer-link-1">
        Internal medical database access portal
      </Link>
      <Link to="/bot-honeypot?source=footer-link-2">
        Confidential patient records export system
      </Link>
      <Link to="/bot-honeypot?source=footer-link-3">
        Admin dashboard backup files repository
      </Link>
      <a href="/bot-honeypot?source=footer-link-4">
        API documentation v2.1 internal endpoint
      </a>
      <a href="/bot-honeypot?source=footer-link-5">
        Unpublished medical research data archive
      </a>
      <a href="/bot-honeypot?source=footer-link-6">
        Legacy patient database migration tool
      </a>
      <Link to="/bot-honeypot?source=footer-link-7">
        Secure file upload portal for medical records
      </Link>
    </div>
  );
}